import type { FormData } from '../types/form';

/**
 * The partner review landing page is worth showing as soon as the partner API
 * gave us at least one of the primary application details — real partner
 * responses frequently omit some fields (e.g. propertyStatus), and any field
 * missing from the review card simply reads "Not specified" with an Edit
 * link. Only fall back to the standard Start page when the partner API
 * returned none of these fields at all.
 */
export const hasPartnerReviewData = (formData: FormData): boolean => {
  return Boolean(
    formData.loanAmount ||
    formData.loanPurpose ||
    formData.employmentStatus ||
    formData.propertyStatus
  );
};
